/**
 * AMPD DCMS2 — CSRF token for scripted writes
 *
 * Writes authenticated by the session cookie (dataset saves, deletes, REST with
 * the session) must carry the session's CSRF token. Forms rendered by the Form
 * component carry it as a hidden field; scripts that send writes with fetch /
 * XHR read it from <meta name="dcms-csrf-token"> and send it in the
 * X-DCMS-CSRF-Token header. Server side: AMPD\DCMS2\Security\Csrf\CsrfGuard.
 *
 * Also exposed as window.dcmsCsrf for inline template scripts:
 *   fetch(url, { method: 'POST', headers: window.dcmsCsrf.headers({ Accept: 'application/json' }) })
 *
 * @copyright AMPD Sp. z o.o. / PTWP-ONLINE Sp. z o.o.
 * @link      https://www.ampd.pl
 * @see       https://docs.ampd.pl Online documentation and examples
 */

export const CSRF_HEADER = 'X-DCMS-CSRF-Token';
export const CSRF_FIELD = 'dcms_csrf_token';
const CSRF_META = 'dcms-csrf-token';

/**
 * Token of the current session, '' when the page has none (e.g. not signed in).
 * Read on every call — never cache it: the session id, and so the token, can change.
 *
 * @returns {string}
 */
export function csrfToken() {
    const meta = document.querySelector('meta[name="' + CSRF_META + '"]');
    return meta ? (meta.getAttribute('content') || '') : '';
}

/**
 * Copy of the given headers with the CSRF header added (when a token exists).
 *
 * @param {Object<string, string>} [headers]
 * @returns {Object<string, string>}
 */
export function csrfHeaders(headers) {
    const out = Object.assign({}, headers || {});
    const token = csrfToken();
    if (token) {
        out[CSRF_HEADER] = token;
    }
    return out;
}

window.dcmsCsrf = {
    header: CSRF_HEADER,
    field: CSRF_FIELD,
    token: csrfToken,
    headers: csrfHeaders,
};
